import { FunctionComponent } from 'react';
import DashboardLayout from '../../components/layout/layout';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useNavigate } from 'react-router-dom';
import { styled } from "@mui/material/styles";
import StorageService from '../../services/storageService';
import { useQueryClient } from '@tanstack/react-query';

const ActionCard = styled(Paper)(({ theme }) => ({
  width: 180,
  height: 100,
  backgroundColor: '#f2f2f2',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  borderRadius: 4,
  cursor: 'pointer',
  textAlign: 'center'
}));

const OtherExtranet: FunctionComponent = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  
  const userInfo = StorageService.getUserInfo();
  const currentExtranet = StorageService.getSelectedExtranet();
  
  const buttons = [
    { 
      label: 'Channel Partner', 
      disabled: currentExtranet === 'Channel Partners',
      icon: <BusinessIcon sx={{ fontSize: 28, color: '#000000' }} />, 
      navigateTo: 'Channel Partners' 
    },
    { 
      label: 'Customer', 
      disabled: true, 
      icon: <PeopleIcon sx={{ fontSize: 28, color: '#000000' }} />, 
      navigateTo: 'Customers' 
    },
    { 
      label: 'Barksdale Admin', 
      disabled: currentExtranet === 'Barksdale Admin',
      icon: <AdminPanelSettingsIcon sx={{ fontSize: 28, color: '#000000' }} />, 
      navigateTo: 'Barksdale Admin' 
    },
  ];

  const handleExtranetSwitch = (extranetValue: string) => {
    if (extranetValue !== currentExtranet) {
      StorageService.setSelectedExtranet(extranetValue);
      StorageService.clearModulePermissions();
      StorageService.clearDetailedPermissions();
      queryClient.clear();
      
      if (extranetValue === 'Barksdale Admin') {
        navigate('/barksdale-admin');
      } else if (extranetValue === 'Channel Partners') {
        navigate('/dashboard');
      } else if (extranetValue === 'Customers') {
        navigate('/customer/custdashboard');
      }
    }
  };

  const showExtranetSwitching = userInfo?.accessLevel === 'BARKSDALE';

  return (
    <>
      <DashboardLayout 
        titleIcon={<DesktopWindowsOutlinedIcon />} 
        title={"Other Extranets"} 
        initialBreadcrumbs={"Extranet"} 
        levelBreadcrumbs={''} 
        breadcrumbs={' Barksdale Admin'} 
        activeMenu={'otherExtranet'} 
        showSupport={false} 
        containerTitle={"Barksdale Administrator"}
        container={true}
      >
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
          
          {showExtranetSwitching && (
            <>
              <Grid container spacing={5}
                sx={{
                  display:'flex',
                  justifyContent: 'normal',
                  alignItems: 'center',
                  maxWidth: '100%',
                }}
              >
                {buttons.map((btn, index) => (
                  <Grid key={index} onClick={() => !btn.disabled && handleExtranetSwitch(btn.navigateTo)}>
                    <ActionCard sx={{ 
                      border: '1px solid #e1e1e1', 
                      boxShadow: ` inset 0 0 10px rgba(0, 0, 0, 0.1), inset 0 0 5px rgba(255, 255, 255, 0.6)`,
                      opacity: btn.disabled ? 0.6 : 1,
                      cursor: btn.disabled ? 'not-allowed' : 'pointer'
                    }}>
                      <Box position="relative">
                        {btn.icon}
                      </Box>
                      <Typography variant="body2" fontWeight="bold" sx={{ width: '65%' }}>
                        {btn.label}
                      </Typography>
                    </ActionCard>
                  </Grid>
                ))}
              </Grid>
            </>
          )}

          {/* Navigation Button */}
          {/* <Box sx={{ mt: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Button 
              variant="contained" 
              sx={{ 
                backgroundColor: '#c3183c', 
                padding: '6px 25px !important', 
                minWidth: '110px'
              }} 
              onClick={() => navigate(-1)}
            >
              BACK
            </Button>
          </Box> */}
        </Box>
      </DashboardLayout>
    </>
  )
};

export default OtherExtranet;